import Background_0 from '@lib/core/src/assets/capabilities-backgrounds/0.png';
import Background_1 from '@lib/core/src/assets/capabilities-backgrounds/1.png';
import Background_2 from '@lib/core/src/assets/capabilities-backgrounds/2.png';
import Background_3 from '@lib/core/src/assets/capabilities-backgrounds/3.png';
import Background_4 from '@lib/core/src/assets/capabilities-backgrounds/4.png';
import Background_5 from '@lib/core/src/assets/capabilities-backgrounds/5.png';
import Background_6 from '@lib/core/src/assets/capabilities-backgrounds/6.png';
import Logo_0 from '@lib/core/src/assets/capabilities-images/0.png';
import Logo_1 from '@lib/core/src/assets/capabilities-images/1.png';
import Logo_2 from '@lib/core/src/assets/capabilities-images/2.png';
import Logo_3 from '@lib/core/src/assets/capabilities-images/3.png';
import Logo_4 from '@lib/core/src/assets/capabilities-images/4.png';
import Logo_5 from '@lib/core/src/assets/capabilities-images/5.png';
import Logo_6 from '@lib/core/src/assets/capabilities-images/6.png';

import {
  WorkflowDtoStatus,
  WorkflowMeetingsContextDtoScope,
  WorkflowMeetingsContextDtoTimeRange
} from '@/api/generated';
import { LocalCapabilityType, ALL_DAYS_OF_WEEK } from '@/components/AiWorkflow/formSchema';

import { PROMPTS } from './prompts';

export type FeaturedTemplateType = LocalCapabilityType & {
  description: string;
  businessArea: string[];
  image: string;
  icon: string;
};

export enum FeaturedTemplateEnum {
  issueSolver = 'ISSUE_SOLVER',
  competitorFinder = 'COMPETITOR_FINDER',
  customerFeedbackFinder = 'CUSTOMER_FEEDBACK_FINDER',
  openQuestionFinder = 'OPEN_QUESTION_FINDER',
  objectionHandler = 'OBJECTION_HANDLER',
  churnWatchAgent = 'CHURN_WATCH_AGENT',
  reputationRadar = 'REPUTATION_RADAR'
}

export const featuredTemplatesData: FeaturedTemplateType[] = [
  {
    image: Background_0,
    icon: Logo_0,
    title: 'Issue Solver',
    description:
      'The Issue Solver template helps identify a core business problem, analyze its root cause, and outline a clear, actionable path to resolution.',
    scope: WorkflowMeetingsContextDtoScope.internal,
    timeRange: WorkflowMeetingsContextDtoTimeRange.yesterday,
    keyWords: [],
    notifications: { email: true },
    trigger: ALL_DAYS_OF_WEEK,
    status: WorkflowDtoStatus.enabled,
    businessArea: ['Other'],
    prompt: PROMPTS.ISSUE_SOLVER,
    createdFrom: FeaturedTemplateEnum.issueSolver
  },
  // {
  //   image: Background_1,
  //   icon: Logo_1,
  //   title: 'Competitor Finder',
  //   description:
  //     'Identifies competitor mentions and market shifts from meetings and websites to inform positioning and GTM.',
  //   scope: WorkflowMeetingsContextDtoScope.all,
  //   timeRange: WorkflowMeetingsContextDtoTimeRange.yesterday,
  //   keyWords: [],
  //   notifications: { email: true },
  //   trigger: ALL_DAYS_OF_WEEK,
  //   status: WorkflowDtoStatus.enabled,
  //   businessArea: ['Marketing'],
  //   prompt: PROMPTS.COMPETITOR_FINDER,
  //   createdFrom: FeaturedTemplateEnum.competitorFinder
  // },
  {
    image: Background_2,
    icon: Logo_2,
    title: 'Customer Feedback Finder',
    description:
      'Pulls clear customer feedback—positive, negative, and quick wins—to guide product and CX decisions.',
    scope: WorkflowMeetingsContextDtoScope.all,
    timeRange: WorkflowMeetingsContextDtoTimeRange.yesterday,
    keyWords: [],
    notifications: { email: true },
    trigger: ALL_DAYS_OF_WEEK,
    status: WorkflowDtoStatus.enabled,
    businessArea: ['CS'],
    prompt: PROMPTS.CUSTOMER_FEEDBACK_FINDER,
    createdFrom: FeaturedTemplateEnum.customerFeedbackFinder
  },
  {
    image: Background_3,
    icon: Logo_3,
    title: 'Open Question Finder',
    description:
      'Surfaces buyer questions left unanswered during calls to ensure nothing slips through the cracks.',
    scope: WorkflowMeetingsContextDtoScope.all,
    timeRange: WorkflowMeetingsContextDtoTimeRange.yesterday,
    keyWords: [],
    notifications: { email: true },
    trigger: ALL_DAYS_OF_WEEK,
    status: WorkflowDtoStatus.enabled,
    businessArea: ['Sales'],
    prompt: PROMPTS.OPEN_QUESTION_FINDER,
    createdFrom: FeaturedTemplateEnum.openQuestionFinder
  },
  {
    image: Background_4,
    icon: Logo_4,
    title: 'Objection Handler Agent',
    description:
      'Flags sales objections—explicit or subtle—and provides response strategies to turn friction into progress.',
    scope: WorkflowMeetingsContextDtoScope.all,
    timeRange: WorkflowMeetingsContextDtoTimeRange.yesterday,
    keyWords: [],
    notifications: { email: true },
    trigger: ALL_DAYS_OF_WEEK,
    status: WorkflowDtoStatus.enabled,
    businessArea: ['Sales'],
    prompt: PROMPTS.OBJECTION_HANDLER_AGENT,
    createdFrom: FeaturedTemplateEnum.objectionHandler
  },
  {
    image: Background_5,
    icon: Logo_5,
    title: 'Churn Watch Agent',
    description:
      'Detects early signs of dissatisfaction or disengagement to help reduce churn and strengthen retention.',
    scope: WorkflowMeetingsContextDtoScope.all,
    timeRange: WorkflowMeetingsContextDtoTimeRange.yesterday,
    keyWords: [],
    notifications: { email: true },
    trigger: ALL_DAYS_OF_WEEK,
    status: WorkflowDtoStatus.enabled,
    businessArea: ['CS'],
    prompt: PROMPTS.CHURN_WATCH_AGENT,
    createdFrom: FeaturedTemplateEnum.churnWatchAgent
  }
  // {
  //   image: Background_6,
  //   icon: Logo_6,
  //   title: 'Reputation Radar',
  //   description:
  //     'Monitors brand perception across meetings and public channels, flagging risks and amplifying wins.',
  //   scope: WorkflowMeetingsContextDtoScope.all,
  //   timeRange: WorkflowMeetingsContextDtoTimeRange.yesterday,
  //   keyWords: [],
  //   notifications: { email: true },
  //   trigger: ALL_DAYS_OF_WEEK,
  //   status: WorkflowDtoStatus.enabled,
  //   businessArea: ['Marketing'],
  //   prompt: PROMPTS.REPUTATION_RADAR,
  //   createdFrom: FeaturedTemplateEnum.reputationRadar
  // }
];

export const createdFromToIcon: Record<string, string> = {
  [FeaturedTemplateEnum.issueSolver]: Logo_0,
  [FeaturedTemplateEnum.competitorFinder]: Logo_1,
  [FeaturedTemplateEnum.customerFeedbackFinder]: Logo_2,
  [FeaturedTemplateEnum.openQuestionFinder]: Logo_3,
  [FeaturedTemplateEnum.objectionHandler]: Logo_4,
  [FeaturedTemplateEnum.churnWatchAgent]: Logo_5,
  [FeaturedTemplateEnum.reputationRadar]: Logo_6
};
